import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Connect to Hubble.',
    desc: "Point your agent to Hubble's MCP server. One integration gives you access to EHRs, payers, pharmacies, and more."
  }, {
    num: '02',
    title: 'Query patient context.',
    desc: 'Your agent requests the data it needs. Hubble normalizes it into a structured, semantic format agents can reason over.'
  }, {
    num: '03',
    title: 'Take clinical actions.',
    desc: 'Go beyond reads. Submit prior authorizations, create orders, update records. All through the same interface.'
  }, {
    num: '04',
    title: 'Ship with confidence.',
    desc: 'Built-in access controls, schema validation, HIPAA compliance, and audit trails. Focus on your product, not the plumbing.'
  }];
  return <section id="how-it-works" className="py-24 relative z-10" data-id="element-50">
      <div className="max-w-7xl mx-auto px-6" data-id="element-51">
        <div className="text-center mb-16" data-id="element-52">
          <span className="text-hubble-accent text-[12px] md:text-[14px] font-body font-medium tracking-[3px] uppercase mb-4 block" data-id="element-53">
            HOW IT WORKS
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-normal tracking-[-1px] text-hubble-text" data-id="element-54">
            From raw clinical data to agent-ready context.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-55">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-hubble-card border border-hubble-border rounded-2xl p-8 hover:border-hubble-primary/50 transition-colors group relative overflow-hidden" data-id="element-56">
              <div className="absolute inset-0 bg-gradient-to-br from-hubble-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-57"></div>

              <div className="font-body text-sm font-medium text-hubble-primary mb-6" data-id="element-58">
                Step {step.num}
              </div>
              <h3 className="font-heading text-xl font-medium text-hubble-text mb-4" data-id="element-59">
                {step.title}
              </h3>
              <p className="font-body text-[16px] text-hubble-body leading-[1.6]" data-id="element-60">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}